module.exports = __webpack_public_path__ + "static/close-icon-white.70c87b64.png";